import { BLOCKS, Document } from '@contentful/rich-text-types'

export const modalDocument: Document = {
  nodeType: BLOCKS.DOCUMENT,
  data: {},
  content: [
    {
      nodeType: BLOCKS.PARAGRAPH,
      content: [
        {
          nodeType: 'text',
          marks: [],
          value: 'Thank you for submitting your application. We will get back to you within 1 business day.',
          data: {},
        },
      ],
      data: {},
    },
  ],
}
